let globalAntdApp = null
let modal = {}
let notification = {}
let message = {}

export default (antdApp) => {
  globalAntdApp = antdApp || {}
  modal = antdApp.modal
  notification = antdApp.notification
  message = antdApp.message
};

export { modal, notification, message }
